import { HttpClient, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { HierarchyService } from './hierarchy.service';
import { LedgerService } from './ledger.service';
@Injectable({
  providedIn: 'root'
})
export class BudgetEffectService {

  constructor(private hierarchyService: HierarchyService, private ledgerService: LedgerService, private spinner: NgxSpinnerService) { }
  async getBudgetObj(eventdata:any, b_acct_id:any, total_amt:any) {
    let bud_obj :any= new Object();

    await this.getActiveFinYear(b_acct_id);
    await this.getAllBudget(b_acct_id);
    let returnObj:any = {}
    let actualBudgetCode:any = []
    for (let i = 0; i < eventdata.length; i++) {
      let bud = this.allBudgetObj[eventdata[i]['ev_ln_dist_bdgt_cd']];
      if (bud) {
        if (eventdata[i]['ev_grp_src_cd'] != "DEDUCTION" && bud['leaf_cd'] != "NONBUD") {
          for (let j = 1; j < 8; j++) {
            if (bud["lvl" + j + "_cd"] == null || bud["lvl" + j + "_cd"] == "" || bud["lvl" + j + "_cd"] == " ") {
              continue;
            }
            if (bud_obj[bud["lvl" + j + "_cd"]] == undefined) {
              bud_obj[bud["lvl" + j + "_cd"]] = 0
            }

            bud_obj[bud["lvl" + j + "_cd"]] = bud_obj[bud["lvl" + j + "_cd"]] + eventdata[i]['ev_ln_amt']

            if (bud['remaining_amount'] < bud_obj[bud["leaf_cd"]]) {
              returnObj['error'] = true;
              returnObj['data'] = `Your payable amount (${total_amt}) exceeds your allocated budget (${bud['leaf_value']} :- ${bud['remaining_amount']})`;
              return returnObj;
            }
          }
          if (!actualBudgetCode.includes(eventdata[i].ev_ln_dist_bdgt_cd)) {
            actualBudgetCode.push(eventdata[i].ev_ln_dist_bdgt_cd)
          }
        }
      } else {
        this.spinner.hide()
        Swal.fire('Error', 'Budget Code "' + eventdata[i]['ev_ln_dist_bdgt_cd'] + '" Is Not Created', 'error');
        return null;
      }

    }
    // return bud_obj
    returnObj['error'] = false;
    returnObj['data'] = bud_obj;
    returnObj['actul_bud'] = actualBudgetCode; 
    return returnObj;
  }
  allBudgetHier :any= [];
  allBudgetObj:any = {};


  fin_year:any
  async getActiveFinYear(b_acct_id:any) {
    var obj:any = new Object();
    obj['b_acct_id'] = b_acct_id;
    var resp = await this.ledgerService.getActiveFinYear(JSON.stringify(obj));
    if (resp['error'] == false) {
      if (resp.data.length == 0) {
        // swal.fire("Warning", "..Active Financial Year Not set!", 'warning');
      } else {
        this.fin_year = resp.data[0].fin_year;
      }
    } else {
      // swal.fire("Error", "..Error while getting active  fin year!", 'error');
    }
  }
  async getAllBudget(b_acct_id:any) {
    var obj:any = new Object();
    obj["b_acct_id"] = b_acct_id;
    obj["table_name"] = "bud_hier";
    var resp = await this.hierarchyService.getBudgetHierarchy(obj);
    if (resp["error"] == false) {
      this.allBudgetHier = resp.data.filter((x:any) => { return x['fin_year'] == this.fin_year });

      for (let i = 0; i < this.allBudgetHier.length; i++) {
        this.allBudgetObj[this.allBudgetHier[i]['leaf_cd']] = this.allBudgetHier[i]
        let str = "";
        for (let j = 1; j < 8; j++) {
          if (
            this.allBudgetHier[i]["lvl" + j + "_cd"] != null &&
            this.allBudgetHier[i]["lvl" + j + "_cd"] != ""
          ) {
            str += this.allBudgetHier[i]["lvl" + j + "_value"] + " > ";
          }
        }

        str = str.substring(0, str.length - 2);
        this.allBudgetHier[i]["desc"] = str;
        // this.budgetObj[this.allBudgetHier[i]["leaf_cd"]] = str;
        // this.hierobj["budget"][this.allBudgetHier[i]["leaf_cd"]] =this.allBudgetHier[i];
      }
    } else {
    }
  }



  async getBudgetObjForManualJournal(manual_data:any, b_acct_id:any) {
    let bud_obj:any = new Object();

    const curret_finyer = await this.getActiveFinYear(b_acct_id);
    await this.getAllBudget(b_acct_id);
    let returnObj :any= {}
    let actualBudgetCode:any = []

    let all_account_lines = JSON.parse(manual_data['data_lines']);
    for (let i = 0; i < all_account_lines.length; i++) {
      let bud = this.allBudgetObj[all_account_lines[i]['data']['bud_cd']];
      if (bud) {
        if (all_account_lines[i]['data']['bud_cd'] != "NONBUD") {
          for (let j = 1; j < 8; j++) {
            if (bud["lvl" + j + "_cd"] == null || bud["lvl" + j + "_cd"] == "" || bud["lvl" + j + "_cd"] == " ") {
              continue;
            }
            if (bud_obj[bud["lvl" + j + "_cd"]] == undefined) {
              bud_obj[bud["lvl" + j + "_cd"]] = 0
            }

            bud_obj[bud["lvl" + j + "_cd"]] = bud_obj[bud["lvl" + j + "_cd"]] + all_account_lines[i]['data']['txn_amt']

            if (bud['remaining_amount'] < bud_obj[bud["leaf_cd"]]) {
              returnObj['error'] = true;
              returnObj['data'] = `Your payable amount (${all_account_lines[i]['data']['txn_amt']}) exceeds your allocated budget (${bud['leaf_value']} :- ${bud['remaining_amount']})`;
              return returnObj;
            }
          }
          if (!actualBudgetCode.includes(all_account_lines[i]['data']['bud_cd'])) {
            actualBudgetCode.push(all_account_lines[i]['data']['bud_cd'])
          }
        }else{
          // console.log("THis is non budget ", all_account_lines[i]['data']['bud_cd'])
        }
      } else {
        this.spinner.hide()
        Swal.fire('Error', 'Budget Code "' + all_account_lines[i]['data']['bud_cd'] + '" Is Not Created', 'error');
        return null;
      }

    }
    // return bud_obj
    returnObj['error'] = false;
    returnObj['data'] = bud_obj;
    returnObj['actul_bud'] = actualBudgetCode; 
    return returnObj;
  }


}
